import { useEventCallback } from 'usehooks-ts';

import { useOpenModal } from '@/shared/components/protectedModals/atoms/modalStack';

export interface ProfileNonToxicModalData {
  tier: number;
  recentFeedback?: {
    totalCount: number;
    positiveRatio: number;
  };
}

export const useOpenProfileNonToxicModal = () => {
  const openModal = useOpenModal();

  return useEventCallback((data: ProfileNonToxicModalData) => {
    openModal({
      type: 'non-toxic-modal',
      data: data,
    });
  });
};
